export type SiteConfig = typeof siteConfig
export const siteConfig = {
    name: "Sprunkl",
    slogan: "slogan",
    icon: "/favicon.ico",
    appleIcon: "/apple-touch-icon.png",
    gameIframe: "https://game.sprunki.com/game.sprunki.html",
    domain: "sprunkl.com",
    gaId: "G-XYEZQHKC19",
    navbarItems: [
        {
            title: "title",
             href: "/",
        }
    ],
}
